// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeClaimsVsActualCosts  {
    _originalTypeClassName = "Loom.BO.EmployeeClaimsVsActualCosts";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeClaimsVsActualCosts.translate = translateService;
}
this.ProjectClaimsVsActualCosts = [];
this.Id = null;
this.ClaimedCosts = null;
this.ActualCosts = null;
this.ClaimedPMs = null;
this.ActualPMs = null;
this.PeriodStart = null;
this.PeriodEnd = null;
this.Employee = null;
this.ActualDays = null;
this.ActualHours = null;
this.PnL = null;
this.EffortGap = null;
this.PnLPercentage = null;
this.EffortGapPercentage = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ClaimedCosts:any;
ActualCosts:any;
ClaimedPMs:any;
ActualPMs:any;
PeriodStart:any;
PeriodEnd:any;
Employee:any;
ActualDays:any;
ActualHours:any;
PnL:any;
EffortGap:any;
PnLPercentage:any;
EffortGapPercentage:any;
ProjectClaimsVsActualCosts:any;
static setProjectClaimsVsActualCosts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectClaimsVsActualCosts == null) $this.ProjectClaimsVsActualCosts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectClaimsVsActualCosts.length > 0) {
                    Domain.EmployeeClaimsVsActualCosts.removeProjectClaimsVsActualCosts($this, $this.ProjectClaimsVsActualCosts[0]);
                }

                Domain.EmployeeClaimsVsActualCosts.addManyProjectClaimsVsActualCosts($this, copyItems);
            }
static addManyProjectClaimsVsActualCosts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeClaimsVsActualCosts.addProjectClaimsVsActualCosts($this, items[i]);
                }
            }
static addProjectClaimsVsActualCosts = ($this, item) => {
                if ($this.ProjectClaimsVsActualCosts == null) $this.ProjectClaimsVsActualCosts = [];
                if (item == null || $this.ProjectClaimsVsActualCosts.indexOf(item) > -1) return;
                $this.ProjectClaimsVsActualCosts.push(item);
Domain.ProjectClaimsVsActualCosts.addEmployeeClaimsVsActualCosts(item, $this);
}
static addRangeProjectClaimsVsActualCosts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeClaimsVsActualCosts.addProjectClaimsVsActualCosts($this, item));
            }
static removeProjectClaimsVsActualCosts = ($this, item) => {
                if ($this == null || $this.ProjectClaimsVsActualCosts == null || $this.ProjectClaimsVsActualCosts.indexOf(item) === -1) return;
                var _index = $this.ProjectClaimsVsActualCosts.indexOf(item);
                $this.ProjectClaimsVsActualCosts.splice(_index, 1);
Domain.ProjectClaimsVsActualCosts.removeEmployeeClaimsVsActualCosts(item, $this);
}
static clearProjectClaimsVsActualCosts = ($this) => { $this.ProjectClaimsVsActualCosts = null; }

static GetEffortGap($this: any): any{return Joove.Common.safeNumber($this?.ClaimedPMs) - Joove.Common.safeNumber($this?.ActualPMs);
}
static GetEffortGapPercentage($this: any): any{return (CLMS.Framework.Number.GreaterThan(() => $this.ClaimedPMs, () => 0) ? Joove.Common.safeNumber(Domain.EmployeeClaimsVsActualCosts.GetEffortGap($this)) / Joove.Common.safeNumber($this?.ClaimedPMs) : 0.0);
}
static GetPnL($this: any): any{return Joove.Common.safeNumber($this?.ClaimedCosts) - Joove.Common.safeNumber($this?.ActualCosts);
}
static GetPnLPercentage($this: any): any{return (CLMS.Framework.Number.GreaterThan(() => $this.ClaimedCosts, () => 0) ? Joove.Common.safeNumber(Domain.EmployeeClaimsVsActualCosts.GetPnL($this)) / Joove.Common.safeNumber($this?.ClaimedCosts) : 0.0);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}